import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { map, Observable, of, switchMap, take } from 'rxjs';
import { AppRoutes, companyRoute } from '../../app.routes';
import { CompanyService } from '../api/company/company.service';
import { Action, PermissionService, Resource } from '../permission/permission.service';

@Injectable({ providedIn: 'root' })
export class DashboardGuard implements CanActivate {

  constructor(
    private companyService: CompanyService,
    private permissionService: PermissionService,
    private router: Router,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.companyService.currentCompany$.pipe(
      take(1),
      switchMap(company => {
        if (!company) {
          return of(true);
        }

        return this.permissionService.getPermissions(company, [Resource.Dashboard]).pipe(
          map(permissions => {
            return permissions.canAccess(Action.Get, Resource.Dashboard)
              ? true
              : this.router.parseUrl(companyRoute(AppRoutes.Appointments, company));
          }),
        );
      }),
    );
  }
}
